var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 5C9.84375 7.67572 7.67494 9.84375 5 9.84375C2.32506 9.84375 0.15625 7.67572 0.15625 5C0.15625 2.32584 2.32506 0.15625 5 0.15625C7.67494 0.15625 9.84375 2.32584 9.84375 5ZM5.12998 1.75781C4.06559 1.75781 3.38672 2.20619 2.85363 3.00309C2.78457 3.10633 2.80768 3.24557 2.90666 3.32063L3.58438 3.83449C3.68604 3.91158 3.83088 3.89324 3.90986 3.79305C4.25877 3.35051 4.49801 3.09389 5.02906 3.09389C5.42807 3.09389 5.9216 3.35068 5.9216 3.7376C5.9216 4.0301 5.68014 4.18031 5.28617 4.40119C4.82672 4.65875 4.21875 4.97932 4.21875 5.78125V5.85938C4.21875 5.98881 4.32369 6.09375 4.45312 6.09375H5.54688C5.67631 6.09375 5.78125 5.98881 5.78125 5.85938V5.83334C5.78125 5.27744 7.40598 5.2543 7.40598 3.75C7.40598 2.61715 6.23088 1.75781 5.12998 1.75781ZM5 6.60156C4.50459 6.60156 4.10156 7.00459 4.10156 7.5C4.10156 7.99539 4.50459 8.39844 5 8.39844C5.49541 8.39844 5.89844 7.99539 5.89844 7.5C5.89844 7.00459 5.49541 6.60156 5 6.60156Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.55327b8963508362ee51eeca6ca5ada4.svg";
export { ForwardRef as ReactComponent };